module.exports = __webpack_public_path__ + "static/img/yfalert1.8c1d5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/yfalert1.png
// module id = 396
// module chunks = 0